import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaixaGerenciarEditarComponent } from './caixa-gerenciar-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: CaixaGerenciarEditarComponent}
  ])],
  exports: [RouterModule]
})
export class CaixaGerenciarEditarRoutingModule { }
